// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a272a5d5","453":"128d95f5","667":"a6777d22","977":"e30eabcc"}[chunkId] + ".chunk.js";
};